import React from 'react';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import SwitchField from 'components/fields/SwitchField';

const styles = theme => ({
  root: {
    borderTop: `1px solid ${theme.palette.primary.A100}`,
    paddingTop: 8,
    paddingBottom: 8,
  },
  typography: {
    paddingBottom: 2,
    marginBottom: 8,
    marginTop: 4,
  },
});

const RolePermissionsCreateEditFormSection = ({
  Group,
  items,
  classes,
}) => (
  <div className={classes.root}>
    <Grid
      container
      alignItems="flex-start"
      spacing={16}
      wrap="nowrap"
    >
      <Grid
        item
        xs={3}
      >
        <Typography
          color="secondary"
          variant="subheading"
          className={classes.typography}
        >
          {Group}
        </Typography>
      </Grid>
      <Grid
        item
        xs={9}
      >
        <div>
          {items.map(item => (
            <Grid
              key={item.ID}
              container
              alignItems="center"
              spacing={16}
              wrap="nowrap"
            >
              <Grid
                item
                xs={12}
              >
                <Field
                  id={`Access.ID-${item.ID}`}
                  name={`Access.ID-${item.ID}`}
                  label={item.Name}
                  component={SwitchField}
                />
              </Grid>
            </Grid>
          ))}
        </div>
      </Grid>
    </Grid>
  </div>
);

RolePermissionsCreateEditFormSection.propTypes = {
  Group: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

RolePermissionsCreateEditFormSection.defaultProps = {
  prefix: '',
};

export default withStyles(styles)(RolePermissionsCreateEditFormSection);



// WEBPACK FOOTER //
// ./src/components/settings/RolePermissionsCreateEditForm/RolePermissionsCreateEditFormSection.js